import { render, staticRenderFns } from "./Botao.vue?vue&type=template&id=4f238301&scoped=true&"
import script from "./Botao.vue?vue&type=script&lang=js&"
export * from "./Botao.vue?vue&type=script&lang=js&"
import style0 from "./Botao.vue?vue&type=style&index=0&id=4f238301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f238301",
  null
  
)

export default component.exports